import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ticketsApi } from "../utils/api";

export default function TicketVerifyPage() {
  const { uid } = useParams();
  const [state, setState]   = useState("loading");
  const [ticket, setTicket] = useState(null);
  const [error, setError]   = useState("");

  useEffect(() => {
    ticketsApi.verifyTicket(uid)
      .then(d => { if(d.valid){setTicket(d.ticket);setState("valid");}else{setError(d.message);setState("invalid");} })
      .catch(e => { setError(e.message); setState("invalid"); });
  }, [uid]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{background:"#07000f"}}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl opacity-10"
          style={{background:`radial-gradient(circle,${state==="valid"&&!ticket?.checkedIn?"#22c55e":state==="invalid"?"#ef4444":"#9b3fe8"},transparent)`}}/>
      </div>

      <div className="w-full max-w-sm relative z-10">
        {state === "loading" && (
          <div className="text-center">
            <div className="w-16 h-16 border-2 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"/>
            <p className="text-gray-400">Verifying your ticket...</p>
          </div>
        )}

        {state === "valid" && ticket && (
          <div className="rounded-3xl overflow-hidden" style={{border:`1px solid ${ticket.checkedIn?"rgba(245,158,11,0.3)":"rgba(34,197,94,0.3)"}`}}>
            {/* Status header */}
            <div className="p-8 text-center" style={{background:ticket.checkedIn?"rgba(245,158,11,0.1)":"rgba(34,197,94,0.1)"}}>
              <div className={`w-20 h-20 rounded-full flex items-center justify-center text-4xl mx-auto mb-4 ${
                ticket.checkedIn ? "bg-yellow-500/20" : "bg-green-500/20"
              }`}>
                {ticket.checkedIn ? "⚠️" : "✅"}
              </div>
              <h1 className={`font-display text-2xl font-bold mb-1 ${ticket.checkedIn ? "text-yellow-300" : "text-green-300"}`}>
                {ticket.checkedIn ? "Already Used" : "Valid Ticket"}
              </h1>
              {ticket.checkedIn
                ? <p className="text-yellow-500/70 text-sm">This ticket was already checked in</p>
                : <p className="text-green-500/70 text-sm">This ticket is valid for entry</p>
              }
            </div>

            {/* Ticket details */}
            <div className="p-6 space-y-3" style={{background:"rgba(255,255,255,0.02)"}}>
              {[
                {label:"Attendee",  value:ticket.attendeeName, highlight:true},
                {label:"Event",     value:ticket.eventTitle},
                {label:"Date",      value:ticket.eventDate},
                {label:"Venue",     value:ticket.venue},
                {label:"Tier",      value:ticket.tier},
                {label:"Order Ref", value:ticket.orderRef},
              ].map(r => (
                <div key={r.label} className="flex justify-between items-start gap-3 py-2 border-b border-white/5 last:border-0">
                  <span className="text-gray-500 text-xs uppercase tracking-wider flex-shrink-0">{r.label}</span>
                  <span className={`text-sm font-medium text-right ${r.highlight ? "text-white font-bold" : "text-gray-300"}`}>{r.value}</span>
                </div>
              ))}
            </div>

            {/* UID */}
            <div className="px-6 py-3 text-center" style={{background:"rgba(0,0,0,0.3)"}}>
              <p className="text-xs font-mono text-gray-600 break-all">{uid}</p>
            </div>
          </div>
        )}

        {state === "invalid" && (
          <div className="rounded-3xl overflow-hidden text-center" style={{border:"1px solid rgba(239,68,68,0.3)"}}>
            <div className="p-8" style={{background:"rgba(239,68,68,0.08)"}}>
              <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center text-4xl mx-auto mb-4">❌</div>
              <h1 className="font-display text-2xl font-bold text-red-300 mb-2">Invalid Ticket</h1>
              <p className="text-gray-400 text-sm">{error || "This QR code is not valid."}</p>
            </div>
            <div className="p-6" style={{background:"rgba(255,255,255,0.02)"}}>
              <Link to="/" className="text-brand-400 hover:text-brand-300 text-sm transition">← Back to events</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}